import { render } from "./SingleBrand.vue?vue&type=template&id=1c48ae42"
import script from "./SingleBrand.vue?vue&type=script&lang=js"
export * from "./SingleBrand.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pdmed-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__